import React, { useState, useEffect } from 'react';
import { inject, observer } from 'mobx-react';
import './ThemeFixedPopupComment.scss';
import RootStore from '../../store/RootStore';
import NewUserTransition from './NewUserTransition';
import { IComment, ICommentType } from './AllForCommentList';
import { style } from '../../utils/image';

let popupTimer = 0 as any;
let lastIndex = -1;
let sourceList = [] as IComment[];

const onMessage = (event: any) => {
  if (event) {
    let { data } = event;
    sourceList = [...sourceList, ...(data as IComment[])];
  }
};

window.addEventListener('comment-messages-change', onMessage);

const PopUpCommentWrapper = (props: {
  enable: boolean;
  newuser?: boolean;
  rootStore?: RootStore;
}) => {
  const { rootStore, enable, newuser } = props;
  const [list, setList] = useState([] as IComment[]);

  const startComment = () => {
    return setInterval(() => {
      let target = sourceList.pop();
      if (target) {
        let newList = [...list];
        if ((newList && newList.length >= 3) || !target) {
          newList.shift();
        }

        if (target) {
          newList = [...newList, target];
        }
        setList(newList);
      }
    }, 3000);
  };

  const stopComment = () => {
    clearInterval(popupTimer);
  };

  useEffect(() => {
    if (enable) {
      popupTimer = startComment();
    } else {
      stopComment();
    }

    return () => {
      stopComment();
    };
  }, [enable, list]);

  const formatMessageContent = (it: IComment) => {
    let { type } = it;
    if (type == ICommentType.TEXT) {
      return it.content;
    }
    if (type == ICommentType.HTML) {
      let span = document.createElement('span');
      try {
        span.innerHTML = decodeURIComponent(it.content);
      } catch (e) {}

      return span.innerText;
    }
    if (type == ICommentType.QUESTION) {
      return it.content;
    }
    if (type == ICommentType.IMAGE) {
      return `发送了一张图片`;
    }
    if (type == ICommentType.FILE) {
      return `发送了一个文件`;
    }
    if (type == ICommentType.GIFT) {
      try {
        let giftData = JSON.parse(it.content);
        return giftData.name + ' X ' + giftData.count;
      } catch (e) {
        return `赠送了一个礼物`;
      }
    }
    if (type == ICommentType.RED_PACKAGE) {
      try {
        let redData = JSON.parse(it.content);
        return `红包：` + redData.content;
      } catch (e) {
        return `发送了一个红包`;
      }
    }
    if (type == ICommentType.EMOTION) {
      try {
        let emotionData = JSON.parse(it.content);
        return emotionData.name;
      } catch (e) {
        return `发送了一个表情`;
      }
    }
    if (type == ICommentType.VOTE) {
      return `主办方发起了一个投票`;
    }
  };

  return (
    <div className="fixed-popup-wrapper">
      {enable
        ? list.map((it: IComment) => {
            let avatar = it.avatar;
            if (avatar) {
              if (avatar.indexOf('//') < 0) {
                avatar = style(avatar, 'avatar_150');
              }
            } else {
              avatar = require('../../assets/logo-128.jpg');
            }
            return (
              <div className="fixed-popup-comment-item" key={it.id}>
                <div className="fixed-popup-comment-item-wrapper">
                  <img src={avatar} />
                  <div className="fixed-popup-comment-item-content">
                    {formatMessageContent(it)}
                  </div>
                </div>
              </div>
            );
          })
        : null}
      {enable && newuser ? <NewUserTransition /> : null}
    </div>
  );
};

export default inject('rootStore')(observer(PopUpCommentWrapper));
